import { useEffect, useRef, useState } from "react";
import { EllipsisVertical } from "lucide-react";
import Button from "../../../components/Button/Button";

/** Kebab menu. items: [{ label, icon, onClick, danger }] */
const ActionMenu = ({ items, disabled = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;
    const close = (event) => {
      if (event.type === "keydown" && event.key !== "Escape") return;
      if (event.type === "mousedown" && menuRef.current?.contains(event.target)) return;
      setIsOpen(false);
    };
    document.addEventListener("mousedown", close);
    document.addEventListener("keydown", close);
    return () => {
      document.removeEventListener("mousedown", close);
      document.removeEventListener("keydown", close);
    };
  }, [isOpen]);

  return (
    <div className="lp-menu" ref={menuRef}>
      <Button
        variant="light"
        size="sm"
        className="lp-btn-icon-only"
        icon={<EllipsisVertical size={16} />}
        onClick={() => setIsOpen((open) => !open)}
        disabled={disabled}
        aria-haspopup="menu"
        aria-expanded={isOpen}
        aria-label="More actions"
      />
      {isOpen && (
        <ul className="lp-menu__list" role="menu">
          {items.map(({ label, icon: Icon, onClick, danger }) => (
            <li key={label}>
              <Button
                variant="plain"
                role="menuitem"
                className={`lp-btn-plain ${danger ? "is-danger" : ""}`}
                icon={Icon ? <Icon size={14} /> : null}
                onClick={() => {
                  setIsOpen(false);
                  onClick();
                }}
              >
                {label}
              </Button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ActionMenu;
